import React from 'react';
import { useHistory } from 'react-router-dom';
import css from './ConfirmationPage.module.css';

// ConfirmationPage: displays a confirmation message after booking
const ConfirmationPage = () => {
  const history = useHistory();

  return (
    <div className={css.root}>
      <h2>Booking Confirmed</h2>
      <p>Your booking request has been received successfully.</p>
      <button className={css.homeButton} onClick={() => history.push('/')}>Go to Home</button>
    </div>
  );
};

export default ConfirmationPage;
